/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Pergi_TInputs */

const en_tut_pergi_t = /** @type {(inputs: Tut_Pergi_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`While you were away, and handovers`)
};

const id_tut_pergi_t = /** @type {(inputs: Tut_Pergi_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selagi Anda pergi, dan serah terima`)
};

/**
* | output |
* | --- |
* | "While you were away, and handovers" |
*
* @param {Tut_Pergi_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_pergi_t = /** @type {((inputs?: Tut_Pergi_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Pergi_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_pergi_t(inputs)
	return en_tut_pergi_t(inputs)
});